
export const TruncateNum=(num)=>num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
